module.exports = __webpack_public_path__ + "static/img/16.a2818c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/16.png
// module id = 6zgR
// module chunks = 0